/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Resourcesrolestitle2Inputs */

const en_settings_resourcesrolestitle2 = /** @type {(inputs: Settings_Resourcesrolestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Understanding User Roles and Permissions`)
};

/**
* | output |
* | --- |
* | "Understanding User Roles and Permissions" |
*
* @param {Settings_Resourcesrolestitle2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_resourcesrolestitle2 = /** @type {((inputs?: Settings_Resourcesrolestitle2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Resourcesrolestitle2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_resourcesrolestitle2(inputs)
});
export { settings_resourcesrolestitle2 as "settings_resourcesRolesTitle" }